/*eslint-disable*/
import '../App.css';
import '../Section.css';
import '../reset.css'
import '../seik-style.css'
import $ from 'jquery';
import 'animate.css';
import { useState, useEffect } from 'react';

function Section4() {

    useEffect(() => {

        const handleResize = () => {
            // 윈도우 크기 변경 시 수행할 작업
            updateRoleElements();
        };

        const updateRoleElements = () => {
            // 크기가 변경될 때 수행할 업데이트 로직
            var wd = $(window).width()
            if (wd < 1025) {
                setMargin([0, 0])
                setMarginX([0, 0])
            } else {
                setMargin([600, 0])
                setMarginX([600, 0])
            }
            
        };

        updateRoleElements();

        // 이벤트 리스너 등록
        window.addEventListener('resize', handleResize);

        // 컴포넌트가 마운트 해제되면 이벤트 리스너 제거
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    // 변하는 값
    let [margin, setMargin] = useState([600, 0])
    // 고정값
    let [marginX, setMarginX] = useState([600, 0])

    const handleOnImg = () => {
        setMargin([margin[0] - 15, margin[1] - 5]);
    };

    const handleOutImg = () => {
        setMargin([marginX[0], marginX[1]]);
    };

    return (
        <div className='section section4 center'>
            <p className='title' style={{ left: "-70px", top: "40%", color: "#fff" }}>-&nbsp;플레이 방법&nbsp;-</p>
            <div className='between' style={{ width: "100%", justifyContent: "space-around" }}>
                <img
                    id="cayon_img"
                    src={`${process.env.PUBLIC_URL}/canyonbg.jpg`}
                    alt="소환사 협곡"
                    style={{ marginRight: `${margin[0]}px`, marginTop: `${margin[1]}px` }}
                    onMouseOver={handleOnImg}
                    onMouseOut={handleOutImg}
                />
                <div className='section_box'>
                    <h3 className='animate__animated animate__fadeInDown' style={{ fontSize: "24px", margin: 0 }}>전설의</h3>
                    <h2 className='animate__animated animate__fadeInDown' style={{ fontSize: "65px" }}>시작</h2>
                    <p className='animate__animated animate__fadeIn' style={{ animationDelay: '0.4s', fontSize: "12px", fontWeight: "bold", letterSpacing: "1px" }}>리그 오브 레전드가 처음이신가요? 가장 인기 있는 게임 모드를 간략히 배워 보세요.</p>
                    <div className='between' style={{ width: "100%", marginTop: "40px" }}>
                        <a id='one' className='play_box_long animate__animated animate__fadeInBottomLeft' style={{ animationDelay: '0.8s', backgroundColor: "#d0a85c" }} href=''>시작하기</a>
                        <a className='play_box_long animate__animated animate__fadeInBottomRight' style={{ animationDelay: '0.8s' }} href=''>지금 플레이하기</a>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Section4